<template>
    <div v-if="caixa">
        <status-ping :tipo="contrato.tipo"
                     :id="contrato._id"/>

        <br/>
        <status-da-onu :_id="caixa._id" v-if="caixa._id && caixa.onu_mac">
            <br/>
            <div class="row">
                <div class="col-sm-3">
                    <label for="nome" class="control-label">NOME DO PAC-PON</label>
                    <input id="nome" disabled type="text" :value="caixa.nome" class="form-control" >
                </div>

                <div class="col-sm-3">
                    <label for="pon" class="control-label">PORTA PON</label>
                    <input id="pon" disabled type="text" :value="(caixa.porta_pon && caixa.porta_pon.nome) ? caixa.porta_pon.nome : null" class="form-control" >
                </div>

                <div class="col-sm-3">
                    <label for="fibra" class="control-label">FIBRA</label>
                    <input id="fibra" disabled type="text" :value="(caixa.fibra.numero) ? 'FO-' + caixa.fibra.numero : null" class="form-control" >
                </div>

                <div class="col-sm-3">
                    <label for="onu_mac" class="control-label">ONU MAC</label>
                    <input id="onu_mac" readonly type="text" :value="caixa.onu_mac" class="form-control" >
                </div>
            </div>

            <br/>
            <div class="row">
                <div class="col-sm-12">
                    <label for="obs" class="control-label">OBS DA PAC-PON</label>
                    <textarea id="obs" readonly rows="5" :value="caixa.obs" class="form-control" ></textarea>
                </div>
            </div>
        </status-da-onu>
        <br/>
        <list-clientes-no-pacpon :_id="caixa._id" v-if="caixa._id"/>
        <br/>
        <place :place="caixa.place" :readonly="true" :height="'300px'" />
    </div>
</template>

<script>
import {
    Place,
    StatusDaOnu,
    ListClientesNoPacpon
} from "../../../components/exports";
import { CaixaPacPon } from "../../../class/index";

export default {
    name: "ContratoOnu",
    components: {
        Place,
        StatusDaOnu,
        ListClientesNoPacpon
    },
    data() {
        return {
            user: null,
            caixa: null
        };
    },
    computed: {
        contrato() {
            return this.$store.state.contrato;
        },
        cliente() {
            return this.$store.state.cliente;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.buscarCaixa();
    },
    methods: {
        async buscarCaixa() {
            if (this.contrato.caixa_pacpon) {
                this.caixa = await CaixaPacPon.byID(
                    this.contrato.caixa_pacpon._id
                );
            }
        }
    }
};
</script>

<style scoped>
</style>
